/**
 * Sentry initialisation.
 *
 * Call initSentry() once at app startup (main.tsx).
 * VITE_SENTRY_DSN must be set in .env / Vercel env vars.
 * In local dev (no DSN) this is a no-op so the console stays clean.
 */
import * as Sentry from '@sentry/react'

export function initSentry(
  dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined,
): void {
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    // 10 % of sessions captured for performance tracing
    tracesSampleRate: 0.1,
    // Releases let Sentry tie errors to source maps from the build
    release: import.meta.env.VITE_APP_VERSION as string | undefined,
  })
}

export { Sentry }
